import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';

var _excluded = ["ariaLabelledBy", "children", "id", "isVisible", "onPointerEnter"];
var propTypes = {
  /** ID of the element that labels this slide (typically the corresponding tab button). Used for accessibility */
  ariaLabelledBy: PropTypes.string.isRequired,
  /** Content to display inside the slide */
  children: PropTypes.node.isRequired,
  /** Unique ID for the slide. Used to link the tab button to this panel via `aria-controls` */
  id: PropTypes.string.isRequired,
  /** Whether the slide is currently visible. Used for conditional rendering or styling */
  isVisible: PropTypes.bool,
  /** Optional handler for pointer enter (hover) events on the slide */
  onPointerEnter: PropTypes.func
};
function ProductCarouselSlide(_ref) {
  var ariaLabelledBy = _ref.ariaLabelledBy,
    children = _ref.children,
    id = _ref.id,
    _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
    onPointerEnter = _ref.onPointerEnter,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    "aria-labelledby": ariaLabelledBy,
    "data-visible": isVisible,
    id: id,
    role: "tabpanel",
    onPointerEnter: onPointerEnter
  }, props), children);
}
ProductCarouselSlide.propTypes = propTypes;

export { ProductCarouselSlide as default };
//# sourceMappingURL=ProductCarouselSlide.js.map
